"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbCheckbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _startsWith = _interopRequireDefault(require("lodash/startsWith"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("../../skybase-core/shapes");

var _sbNonEditableControl = require("../sb-non-editable-control");

var keyCodes = _interopRequireWildcard(require("../../skybase-core/constants/keyCodes"));

var _uuid = require("uuid");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var LEFT = _constants.checkboxLabelPosition.LEFT,
    RIGHT = _constants.checkboxLabelPosition.RIGHT;

var SbCheckbox = /*#__PURE__*/function (_Component) {
  _inherits(SbCheckbox, _Component);

  var _super = _createSuper(SbCheckbox);

  function SbCheckbox(props) {
    var _this;

    _classCallCheck(this, SbCheckbox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function () {
      var _this$props = _this.props,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      if (!disabled) {
        onChange(!checked);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      var onClick = _this.props.onClick;

      if (!onClick) {
        _this.handleOnChange();

        if (event) {
          // Prevent the default event only when we click directly on input.
          // Since the input is hidden, this can only occur when we click on the parent label.
          if (event.target && event.target.tagName !== 'INPUT') {
            event.preventDefault();
          }

          if (event.nativeEvent && event.nativeEvent.stopImmediatePropagation) {
            event.nativeEvent.stopImmediatePropagation();
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnKeyUp", function (event) {
      var onKeyUp = _this.props.onKeyUp;

      if (!onKeyUp) {
        var keyCode = event.keyCode;
        event.preventDefault();

        if (keyCode === keyCodes.space || keyCode === keyCodes.enter) {
          _this.handleOnChange();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getClasses", function () {
      var _this$props2 = _this.props,
          checked = _this$props2.checked,
          indeterminate = _this$props2.indeterminate,
          disabled = _this$props2.disabled,
          type = _this$props2.type; // classNames

      return {
        checked: checked,
        indeterminate: indeterminate,
        unchecked: !checked,
        disabled: disabled,
        'sb-checkbox': true,
        'switch-control': type === 'switch-control'
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderLabel", function (value, position) {
      var labelPosition = _this.props.labelPosition;
      return value && labelPosition === position && /*#__PURE__*/_react.default.createElement("div", {
        id: _this.labelID,
        className: "children-".concat(position)
      }, value);
    });

    _this.labelID = (0, _uuid.v4)();
    return _this;
  }

  _createClass(SbCheckbox, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          editable = _this$props3.editable,
          checked = _this$props3.checked,
          children = _this$props3.children,
          id = _this$props3.id,
          labelPosition = _this$props3.labelPosition,
          labelTrue = _this$props3.labelTrue,
          labelFalse = _this$props3.labelFalse,
          onClick = _this$props3.onClick,
          onKeyUp = _this$props3.onKeyUp,
          style = _this$props3.style,
          inputRef = _this$props3.inputRef,
          indeterminate = _this$props3.indeterminate,
          value = _this$props3.value,
          type = _this$props3.type,
          rest = _objectWithoutProperties(_this$props3, ["className", "disabled", "editable", "checked", "children", "id", "labelPosition", "labelTrue", "labelFalse", "onClick", "onKeyUp", "style", "inputRef", "indeterminate", "value", "type"]);

      var labelValue = children || (checked ? labelTrue : labelFalse);
      /**
       * If editable=false was set, render just value.
       */

      if (editable === false) {
        return /*#__PURE__*/_react.default.createElement(_sbNonEditableControl.SbNonEditableControl, {
          value: labelValue,
          inputRef: inputRef,
          id: id,
          className: className
        });
      }

      var dataAttributes = (0, _pickBy.default)(this.props, function (_, key) {
        return (0, _startsWith.default)(key, 'data-');
      });
      var isChecked = checked && !indeterminate;
      return /*#__PURE__*/_react.default.createElement("label", {
        id: id,
        className: (0, _classnames.default)(this.getClasses(), className),
        style: style,
        onClick: this.handleOnClick,
        onKeyUp: this.handleOnKeyUp,
        "aria-checked": isChecked,
        tabIndex: disabled ? '-1' : '0'
      }, this.renderLabel(labelValue, LEFT), /*#__PURE__*/_react.default.createElement("input", _extends({}, rest, {
        type: "checkbox",
        checked: isChecked,
        disabled: disabled,
        onChange: function onChange() {},
        ref: inputRef,
        onClick: onClick,
        onKeyUp: onKeyUp,
        value: value
      }, dataAttributes)), /*#__PURE__*/_react.default.createElement("div", {
        className: "square",
        role: type === 'switch-control' ? 'switch' : 'checkbox',
        "aria-checked": isChecked,
        "aria-labelledby": this.labelID
      }, isChecked && /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-checkhook"
      })), this.renderLabel(labelValue, RIGHT));
    }
  }]);

  return SbCheckbox;
}(_react.Component);

exports.SbCheckbox = SbCheckbox;

_defineProperty(SbCheckbox, "propTypes", {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  id: _propTypes.default.string,
  indeterminate: _propTypes.default.bool,
  labelFalse: _propTypes.default.string,
  labelTrue: _propTypes.default.string,
  labelPosition: _propTypes.default.oneOf([LEFT, RIGHT]),
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  inputRef: _shapes.PropTypeRef,
  style: _propTypes.default.object // eslint-disable-line

});

_defineProperty(SbCheckbox, "defaultProps", {
  className: null,
  disabled: false,
  editable: true,
  checked: false,
  id: null,
  indeterminate: false,
  labelTrue: null,
  labelFalse: null,
  labelPosition: RIGHT,
  onChange: NOOP,
  onClick: null,
  onKeyUp: null,
  value: undefined,
  inputRef: NOOP,
  style: {}
});
//# sourceMappingURL=sb-checkbox.js.map